export default __webpack_public_path__ + "static/skillsEmailMobile-ffa47d33aa5b05ba03ce2b0bd47fa485.mp4";